import { type ComponentType, lazy } from 'react'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  bulkRoleModifyAccessControl,
  bulkUserModifyAccessControl,
  accountManagementBulkAdminAccessControl,
  accountManagementBulkApprovalsAccessControl,
} from '../access-control/accountManagementBulkAdminAccess.configuration'

// Router files are critical-path bundles — page components are lazy-loaded (workspace rule).
const BulkOverviewPage = lazy(
  () =>
    import(/* webpackChunkName: "BulkOverviewPage" */ '../pages/BulkOverviewPage/BulkOverviewPage')
)
const BulkUsersPage = lazy(
  () => import(/* webpackChunkName: "BulkUsersPage" */ '../pages/BulkUsersPage/BulkUsersPage')
)
const BulkRolesPage = lazy(
  () => import(/* webpackChunkName: "BulkRolesPage" */ '../pages/BulkRolesPage/BulkRolesPage')
)
const BulkOperationDetailPage = lazy(
  () =>
    import(
      /* webpackChunkName: "BulkOperationDetailPage" */
      '../pages/BulkOperationDetailPage/BulkOperationDetailPage'
    )
)
const BulkOperationsListPage = lazy(
  () =>
    import(
      /* webpackChunkName: "BulkOperationsListPage" */
      '../pages/BulkOperationsListPage/BulkOperationsListPage'
    )
)
const BulkApprovalsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "BulkApprovalsPage" */ '../pages/BulkApprovalsPage/BulkApprovalsPage'
    )
)
const BulkAuditPage = lazy(
  () => import(/* webpackChunkName: "BulkAuditPage" */ '../pages/BulkAuditPage/BulkAuditPage')
)

/**
 * Editor + detail routes (requirements §4). They are registered as independent top-level
 * admin routes (not nested under the `app-admin-account-management-bulk` wrapper) because
 * IPP nests a router's children under the wrapper's path prefix, and §4 mandates the exact
 * URLs `/admin/users/bulk`, `/admin/roles/bulk`, `/admin/bulk/operations/:operationId`.
 * Each element is spread into the shared admin `<DashSwitch>` via `domainDefinition`.
 */
export const accountManagementBulkEditorRouters = [
  <DomainRoute
    key="app-admin-account-management-bulk-overview"
    exact
    route="app-admin-account-management-bulk-overview"
    component={BulkOverviewPage as ComponentType<any>}
    accessControl={accountManagementBulkAdminAccessControl}
  />,
  <DomainRoute
    key="app-admin-account-management-bulk-users"
    exact
    route="app-admin-account-management-bulk-users"
    component={BulkUsersPage}
    accessControl={bulkUserModifyAccessControl}
  />,
  <DomainRoute
    key="app-admin-account-management-bulk-roles"
    exact
    route="app-admin-account-management-bulk-roles"
    component={BulkRolesPage as ComponentType<any>}
    accessControl={bulkRoleModifyAccessControl}
  />,
  <DomainRoute
    key="app-admin-account-management-bulk-operations"
    exact
    route="app-admin-account-management-bulk-operations"
    component={BulkOperationsListPage as ComponentType<any>}
    accessControl={accountManagementBulkAdminAccessControl}
  />,
  <DomainRoute
    key="app-admin-account-management-bulk-operations-detail"
    exact
    route="app-admin-account-management-bulk-operations-detail"
    component={BulkOperationDetailPage as ComponentType<any>}
    accessControl={accountManagementBulkAdminAccessControl}
  />,
  <DomainRoute
    key="app-admin-account-management-bulk-approvals"
    exact
    route="app-admin-account-management-bulk-approvals"
    component={BulkApprovalsPage as ComponentType<any>}
    accessControl={accountManagementBulkApprovalsAccessControl}
  />,
  <DomainRoute
    key="app-admin-account-management-bulk-audit"
    exact
    route="app-admin-account-management-bulk-audit"
    component={BulkAuditPage as ComponentType<any>}
    accessControl={accountManagementBulkAdminAccessControl}
  />,
]
